import { useCallback } from "react";

import type { ReservationRequestHandlingInput } from "@/lib/gql/__generated__/graphql";

import * as MutationRepository from "../../repository/mutation";

export const useUpdateReservationDetailReservationRequestHandling = (hotelID: string, reservationID: string) => {
	const { onReservationDetailReservationRequestHandling } =
		MutationRepository.useReservationDetailReservationRequestHandlingUpdateMutation();

	/**
	 * リクエスト予約の承認を実行
	 */
	const onUpdateReservationDetailReservationRequestHandlingAccept = useCallback(async () => {
		const input: ReservationRequestHandlingInput = {
			hotelID,
			reservationID,
			accept: true,
		} satisfies ReservationRequestHandlingInput;
		await onReservationDetailReservationRequestHandling(input);
	}, [onReservationDetailReservationRequestHandling, hotelID, reservationID]);

	/**
	 * リクエスト予約の非承認を実行
	 */
	const onUpdateReservationDetailReservationRequestHandlingReject = useCallback(async () => {
		const input: ReservationRequestHandlingInput = {
			hotelID,
			reservationID,
			accept: false,
		} satisfies ReservationRequestHandlingInput;
		await onReservationDetailReservationRequestHandling(input);
	}, [onReservationDetailReservationRequestHandling, hotelID, reservationID]);

	return {
		onUpdateReservationDetailReservationRequestHandlingAccept,
		onUpdateReservationDetailReservationRequestHandlingReject,
	};
};
